import { render, staticRenderFns } from "./NovaNotificacao.vue?vue&type=template&id=d5d3c726&scoped=true&"
import script from "./NovaNotificacao.vue?vue&type=script&lang=js&"
export * from "./NovaNotificacao.vue?vue&type=script&lang=js&"
import style0 from "./NovaNotificacao.vue?vue&type=style&index=0&id=d5d3c726&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d3c726",
  null
  
)

export default component.exports